export default __webpack_public_path__ + "static/media/api-community.3b53010b.png";